/**
 * @typedef {import('../index').LegacyCustomAttribute} LegacyCustomAttribute
 */

/**
 * @param {Array<LegacyCustomAttribute>} newAttrList
 * @param {Array<LegacyCustomAttribute>} existingAttrList
 * @return {Array<LegacyCustomAttribute>}
 */
export const removeExistingAttributes = (newAttrList, existingAttrList) => {
  const existingAttrSet = new Set(existingAttrList.map((item) => item['name']))
  return newAttrList.filter((item) => !existingAttrSet.has(item['name']))
}
